import { Box, Typography, TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import { AppFormLabel } from 'components/core/AppFormLabel/AppFormLabel';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useToggle } from '@alluradirect/react';
import styled from 'styled-components';

interface Props {
  title?: string;
  description?: string;
}

const StyledTextField = styled(TextField)`
 & .MuiInputLabel-root {
  position: absolute !important;
 }

 & .Mui-disabled {
    pointer-events: none;
  }
`;

export type AppTextFieldProps = Props & TextFieldProps;

export const AppTextField = ({
  title,
  description,
  size = 'small',
  fullWidth = true,
  ...textFieldProps
}: AppTextFieldProps) => {
  return (
    <>
      <Box marginBottom={title || description ? '8px' : '0px'}>
        {title ? <AppFormLabel title={title} /> : null}
        {description ? <Typography variant="body2">{description}</Typography> : null}
      </Box>
      <StyledTextField fullWidth={fullWidth} size={size} {...textFieldProps} />
    </>
  );
};

export const AppPasswordTextField = (props: Omit<AppTextFieldProps, 'type'>) => {
  const toggle = useToggle({ isOpen: false });

  return (
    <AppTextField
      type={toggle.isOpen ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={toggle.toggle}>
              {toggle.isOpen ? <VisibilityIcon fontSize={'small'} /> : <VisibilityOffIcon fontSize={'small'} />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};
